<fa-icon class="icon" icon="question-circle" [matTooltipClass]="multiline ? 'multiline' : ''" [matTooltip]="hint" (click)="onTooltipClick()"></fa-icon>
